import { render, staticRenderFns } from "./EditReplyButton.vue?vue&type=template&id=02435992"
import script from "./EditReplyButton.vue?vue&type=script&lang=js"
export * from "./EditReplyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports